import { render, staticRenderFns } from "./SocietyFormFiles.vue?vue&type=template&id=8bb3ad6c&scoped=true&"
import script from "./SocietyFormFiles.vue?vue&type=script&lang=js&"
export * from "./SocietyFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./SocietyFormFiles.vue?vue&type=style&index=0&id=8bb3ad6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb3ad6c",
  null
  
)

export default component.exports